import { render, staticRenderFns } from "./HotspotList.vue?vue&type=template&id=27d282b2&"
import script from "./HotspotList.vue?vue&type=script&lang=ts&"
export * from "./HotspotList.vue?vue&type=script&lang=ts&"
import style0 from "./HotspotList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports